export const COMMON_MESSAGES = {
  SUPPORT_LINK: "https://hub.safeex.com/support/home",
  STATUS_LINK: "https://status.safeex.com/",
}
